import {default as OneSignalPlugin} from "onesignal-cordova-plugin";
import {Injectable} from "@angular/core";

@Injectable()
export class Session {
  /**
   * Add an outcome with the provided name, captured against the current session.
   */
  addOutcome(name: string): void {
    OneSignalPlugin.Session.addOutcome(name);
  };

  /**
   * Add a unique outcome with the provided name, captured against the current session.
   */
  addUniqueOutcome(name: string): void {
    OneSignalPlugin.Session.addUniqueOutcome(name);
  };

  /**
   * Add an outcome with the provided name and value, captured against the current session.
   */
  addOutcomeWithValue(name: string, value: number): void {
    OneSignalPlugin.Session.addOutcomeWithValue(name, value);
  };
}
